<div class="card"
     *ngIf="view"
     [class.live]="view.isLive"
     [class.done]="view.isDone"
     [class.stale]="item.isStale && !view.isDone"
     [class.red]="view.isLive && item.severity === 'red'"
     [class.orange]="view.isLive && item.severity === 'orange'"
     [class.yellow]="view.isLive && item.severity === 'yellow'"
     [class.green]="view.isLive && item.severity === 'green'"
     [class.selected]="selected"
     [class.unread]="isUnread"
     (click)="onClick()">

  <div class="header">
    <span class="unread-dot" *ngIf="isUnread" title="Unread"></span>
    <span class="chip owner" *ngIf="ownerName" title="Whose item">{{ ownerName }}</span>
    <span class="chip">{{ view.sourceChip }}</span>
    <span class="chip portfolio" *ngIf="view.portfolioChip" [title]="view.subjectLabel">{{ view.portfolioChip }}</span>
    <span class="headline" [title]="view.headline">{{ view.headline }}</span>
    <span class="badge overdue" *ngIf="view.overdue > 0">OVERDUE {{ view.overdue }} {{ view.overdue === 1 ? 'DAY' : 'DAYS' }}</span>
    <span class="tags" *ngIf="view.isDone">
      <span class="tag sev" *ngIf="view.severityLabel" [class.red]="item.severity === 'red'" [class.orange]="item.severity === 'orange'" [class.yellow]="item.severity === 'yellow'">{{ view.severityLabel }}</span>
      <span class="tag state">{{ view.completionTag }}</span>
    </span>
    <span class="tags" *ngIf="!view.isDone && item.isStale && item.itemType !== 'AvailableAdjustment'">
      <span class="tag state">STALE</span>
    </span>
    <span class="tags" *ngIf="view.availabilityLabel"><span class="tag state">{{ view.availabilityLabel }}</span></span>
    <span class="time">{{ view.originated }}</span>
    <button type="button" class="mark-unread" *ngIf="canMarkUnread && item.readAtUtc && !item.completedAtUtc"
            title="Mark as unread" (click)="onMarkUnread($event)">✉</button>
    <span class="chevron">{{ selected ? '◀' : '▶' }}</span>
  </div>
</div>
